// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-CameraPermissions-Recover-absolute-center","text":"onfido-sdk-ui-CameraPermissions-Recover-text","instructions":"onfido-sdk-ui-CameraPermissions-Recover-instructions","instructionsTitle":"onfido-sdk-ui-CameraPermissions-Recover-instructionsTitle","recovery":"onfido-sdk-ui-CameraPermissions-Recover-recovery","steps":"onfido-sdk-ui-CameraPermissions-Recover-steps","step":"onfido-sdk-ui-CameraPermissions-Recover-step","button":"onfido-sdk-ui-CameraPermissions-Recover-button"};


//////////////////
// WEBPACK FOOTER
// ./components/CameraPermissions/Recover/style.css
// module id = 370
// module chunks = 1